export const RequestType = {
  NEW: "NEW",
  UPDATE: "UPDATE",
  NONE: "NONE",
} as const;

export const STARTPAGETITLES = {
  QUICKLINKSTITLE: "quicklinkstitle",
  RECENT_UPDATED_FILES_PAGE_TITLE: "recentupdatedfilespagetitle",
  RECENT_UPDATED_FILES_START_PAGE_TITLE: "recentupdatedfilesstartpagetitle",
  MOSTLY_VISITED_TITLE: "mostlyvisitedtitle",
  UPDATE_NOTIFICATION: "updatenotification",
  SEARCHBAR_TOOLTIP: "searchbartooltip",
} as const;

export const DISPATCHES = {
  SEARCH_INPUT_ACTION: "SEARCH_INPUT_ACTION",
  SAGA_GET_NAVIGATION_MENU_DATA: "SAGA_GET_NAVIGATION_MENU_DATA",
  SAGA_GET_QUICKLINKS_DATA: "SAGA_GET_QUICKLINKS_DATA",
  SAGA_GET_RESOURCELINKS_DATA: "SAGA_GET_RESOURCELINKS_DATA",
  INCREMENT: "INCREMENT",
  DECREMENT: "DECREMENT",
  SEARCH_INPUT_SET_ACTION: "SEARCH_INPUT_SET_ACTION",
  SEARCH_RESULT_DISPATCH_ACTION: "SEARCH_RESULT_DISPATCH_ACTION",
  SEARCH_INPUT_RESET_ACTION: "SEARCH_INPUT_RESET_ACTION",
  SET_MATCHING_KEYWORDS_STRINGS: "SET_MATCHING_KEYWORDS_STRINGS",
  SET_MATCHING_INDIVIDUAL_KEYWORDS_ARRAY:
    "SET_MATCHING_INDIVIDUAL_KEYWORDS_ARRAY",
  GET_SP_KEYWORDS: "GET_SP_KEYWORDS",
  SET_SP_KEYWORDS: "SET_SP_KEYWORDS",
  SET_STARTPAGE_TEXT: "SET_STARTPAGE_TEXT",
  GET_SP_WEBSITES: "GET_SP_WEBSITES",
  SET_SP_WEBSITES: "SET_SP_WEBSITES",
  SET_USER_SELECTED_INPUT_KEYWORD: "SET_USER_SELECTED_INPUT_KEYWORD",
  GET_USER_SELECTED_INPUT_KEYWORD: "GET_USER_SELECTED_INPUT_KEYWORD",
  SET_MATCHING_WEBSITES_ARRAY: "SET_MATCHING_WEBSITES_ARRAY",
  SET_HANDLE_KEY_DOWN_INPUT: "SET_HANDLE_KEY_DOWN_INPUT",
  SET_CLICKED_ITEM: "SET_CLICKED_ITEM",
  SET_QUICK_LINKS: "SET_QUICK_LINKS",
  SET_USER_ACCESS_TO_RESTRICTED_LINKS: "SET_USER_ACCESS_TO_RESTRICTED_LINKS",
  SEARCH_RESULT_SAGA: "SEARCH_RESULT_SAGA",
  SEARCH_STATISTICS_SAGA: "SEARCH_STATISTICS_SAGA",
  SEARCH_KEYWORD_SAGA: "SEARCH_KEYWORD_SAGA",
  INITIALIZE_SAGA: "INITIALIZE_SAGA",
} as const;

export type DISPATCHES = (typeof DISPATCHES)[keyof typeof DISPATCHES];

export const SPSELECTS = {
  SITELINKS: "Id,Title,Link,Image,Description,Section,SectionDescription",
  NAVIGATIONITEMS: "Id,Title,Link,ParentId,ItemOrder",
  QUICKLINKS: "Id,Title,Link,Image,Description,LinkOrder",
  HEROIMAGES: "Id,Title,Section,Link,IconOrder,ImageText,ImageUrl",
  RESOURCELINKS:
    "Id,Title,Link,Emoji,Section,Protected,Description,Image,FrequentlyVisited",
  KEYWORDS: "Id,KeyWords,WebSiteURLIDIndex",
  BANNERIMAGE: "Id,ID,Title,ImageUrl",
  FOOTERSECTIONIMAGES: "Id,ID,Title,Link,Image,Description,ImageOrder",
  RECENTLYUPDATEDPAGES: "Id,ID,Title,Link,Date",
  RECENTLYUPDATEDFILES: "Id,ID,Title,Link,Date",
  TITLETEXTS: "Id,Title,Description,TitlePosition",
  CURRENTNEWS:
    "Title,WikiField,FileRef,Created,Modified,CanvasContent1,BannerImageUrl",
} as const;

export type SPSELECTS = (typeof SPSELECTS)[keyof typeof SPSELECTS];

export const IMAGESECTIONS = {
  TOP_IMAGE: "TopImg", //iconorder = 1
  RIGHT_IMG_TOP_LEFT: "RightImgTopLeft", //iconorder = 3
  RIGHT_IMG_TOP_RIGHT: "RightImgTopRight", //iconorder = 4
  RIGHT_IMG_BOTTOM_LEFT: "RightImgBottomLeft", //iconorder = 5
  RIGHT_IMG_BOTTOM_RIGHT: "RightImgBottomRight", //iconorder = 6
  LEFT_IMAGE: "LeftImg", //iconorder = 2
} as const;

export const WEBSITE_SEARCH_URL =
  "https://logistikportalen.fmv.se/_layouts/15/osssearchresults.aspx?u=https%3A%2F%2Flogistikportalen%2Efmv%2Ese&k";

